import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import slick from "slick-carousel/slick/slick.js";

import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';
import slickCss from "slick-carousel/slick/slick.scss";
import slickTheme from "slick-carousel/slick/slick-theme.scss";

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="../assets/images/icon-slider-prev-lg.png" />', '<img src="../assets/images/icon-slider-next-lg.png" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              margin: 36,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
              margin: 36,
            }
          }
        });
      });
    }

    // modaal
    function modaal() {
      // ====================
      // <HTML>
      // <a href="path/to/image.jpg" class="js-modal-image" data-modaal-desc="My Description">Show</a>
      // or
      // <button data-modaal-content-source="path/to/image.jpg" class="js-modal-image">Show</button>
      // ====================

      $('.js-modal-image').modaal({
        type: 'image'
      });
    }

    // slick
    function slickSlider() {
      $('.js-slider-main').each(function (i, elm) {
        var $slider_area = $(elm).parent();
        var $main_slide = $slider_area.find(".js-slider-main");
        var $thumb_slide = $slider_area.find(".js-thumb");


        // データ属性の数字を割り振る
        $thumb_slide.find('.js-thumb-item').each(function () {
          var index = $thumb_slide.find('.js-thumb-item').index(this);
          $(this).attr("data-index", index);
        });

        // 初期化
        $main_slide.on('init', function (slick) {
          $thumb_slide.find(".js-thumb-item:first-child").addClass('is-current');
        });

        // サムネイルをクリックした時スライダー切り替え
        $thumb_slide.find(".js-thumb-item").on('click', function () {
          var index = $(this).attr("data-index");
          $main_slide.slick("slickGoTo", index, false);
        });
        $thumb_slide.on('init', function(event, slick){
          $(".c-box-property__slider").addClass("is-loaded-thumbnail");
        });

        // サムネイル画像のカレントを切り替え
        $main_slide.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          $thumb_slide.find(".js-thumb-item").removeClass("is-current");
          $thumb_slide.find('.js-thumb-item[data-index="' + nextSlide + '"]').addClass("is-current");
        });


        // オプション
        $main_slide.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          accessibility: false,
          dots: false,
          arrows: true,
          fade: false,
          responsive: [
            {
              breakpoint: 750,
              settings: {}
            },
          ]
        });
      });

      $('.c-works-slider__main').slick({
        infinite: true,
        arrow: true,
        slidesToShow: 1,
        variableWidth: false,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev" style="background-image:url(/assets/images/icon-slider-prev-lg.png)"></div>',
        nextArrow: '<div class="slick-next" style="background-image:url(/assets/images/icon-slider-next-lg.png)"></div>',
        asNavFor: '.c-works-slider__thumbnail',
        autoplaySpeed:2500,
        responsive:[{
          breakpoint:750,
          settings:{
            dots: false,
            variableWidth: false,
            autoplaySpeed:2500,
            slidesToShow:1
          }
        }]
      });
      $('.c-works-slider__thumbnail').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 400,
        arrows: true,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.c-works-slider__main',
        focusOnSelect: true,
        prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
        nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
        responsive:[{
          breakpoint:750,
          settings:{
            dots: false,
            variableWidth: false,
            autoplaySpeed:2500,
            slidesToShow:4
          }
        }]
      });
    }

    $(function () {
      menuSlide();
      owlCarousel();
      modaal();
      slickSlider();
      $(window).on('load', function() {
        // setTimeout(()=>{

        // },20000)
      });
    });
  }
}

window.GApp = new App();
